import Application from "../../Application";
import Report2Presenter, {
  IReport2Presenter
} from "../../presenter/report/Report2Presenter";

export default class ShowReport2PageInteractor {
  private application: Application;
  private output?: IReport2Presenter;

  constructor(application) {
    this.application = application;
  }

  execute() {
    this.output = Report2Presenter({
      application: this.application,
      initialState: {
        report2PeriodFrom: undefined,
        report2PeriodTo: undefined,
        report2Min: undefined,
        report2Max: undefined,
        report2EvaluationStatus: undefined,
        report2: undefined
      }
    });

    return this.output;
  }
}
